import React from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import InjectedCheckoutForm from "./InjectedCheckoutForm";

import config from "../../config";
// Create the Stripe object yourself...
const stripePromise = loadStripe(config.publishableStripeKey);

const StripeCheckOut = (props) => {
  return (
    <Elements stripe={stripePromise}>
      <InjectedCheckoutForm
        onSubmit={(token, recaptchaValue) => props.onSubmit(token, recaptchaValue)}
      />
    </Elements>
  );
};

export default StripeCheckOut;



// WEBPACK FOOTER //
// ./src/layout/stripe/StripeCheckOut.js